import { Link } from 'react-router-dom';
import { Logo } from '@/components/Logo';

export function Footer() {
  return (
    <footer className="border-t border-border bg-muted/30">
      <div className="container py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="space-y-4">
            <Link to="/" className="flex items-center gap-2">
              <Logo size="md" />
              <span className="font-bold text-lg">AutomotiveAPI</span>
            </Link>
            <p className="text-sm text-muted-foreground">
              The open data standard for automotive. Free, unified data structures for seamless integration.
            </p>
          </div>

          <div>
            <h3 className="font-semibold mb-4 text-base">Company</h3>
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li><Link to="/about" className="hover:text-foreground transition-colors">About</Link></li>
              <li><Link to="/use-cases" className="hover:text-foreground transition-colors">Use Cases</Link></li>
              <li><Link to="/partners" className="hover:text-foreground transition-colors">Partners</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="font-semibold mb-4 text-base">Standards</h3>
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li><Link to="/api-standards?category=people" className="hover:text-foreground transition-colors">People</Link></li>
              <li><Link to="/api-standards?category=inventory" className="hover:text-foreground transition-colors">Inventory</Link></li>
              <li><Link to="/api-standards?category=service" className="hover:text-foreground transition-colors">Service</Link></li>
              <li><Link to="/api-standards?category=parts" className="hover:text-foreground transition-colors">Parts</Link></li>
              <li><Link to="/api-standards?category=transactions" className="hover:text-foreground transition-colors">Transactions</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="font-semibold mb-4 text-base">Tools</h3>
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li><Link to="/api-standards" className="hover:text-foreground transition-colors">Schema Validator</Link></li>
              <li><Link to="/docs" className="hover:text-foreground transition-colors">Documentation</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="font-semibold mb-4 text-base">Resources</h3>
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li><Link to="/docs" className="hover:text-foreground transition-colors">Getting Started</Link></li>
              <li><Link to="/docs/data-types" className="hover:text-foreground transition-colors">Data Type Reference</Link></li>
              <li><Link to="/proposals" className="hover:text-foreground transition-colors">Community Proposals</Link></li>
              <li><Link to="/contact" className="hover:text-foreground transition-colors">Contact</Link></li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-border/40 text-center text-sm text-muted-foreground">
          <p>&copy; {new Date().getFullYear()} AutomotiveAPI. Open source. Free forever.</p>
        </div>
      </div>
    </footer>
  );
}
